import "./statscard.scss";

export interface IStatsCard {
    type: "dark" | "light" | "gray";
    title: string
    desc: string
}

const StatsCard = ({type, title, desc}: IStatsCard) => {
    return (
        <div className="Stats-Card" data-type={type}>
            <img
                src={type === "dark" ? require("../../../assets/images/icons/StatsLight.svg").default : require("../../../assets/images/icons/StatsDark.svg").default}
                alt="" className="img-fluid Stats-Card-Image"/>
            <span className="Stats-Card-Title">{title}</span>
            <p className="Stats-Card-Desc">{desc}</p>
        </div>
    )
}

export default StatsCard